import Image from "next/image";
import React from "react";
import styles from "./about-forestry.module.css";
import forest from "../../assets/images/about/forest.webp";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
import Head from "next/head";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Link from "next/link";
const About_Forest_Service = () => {
 
  return (
    <>
              <Head>
                <meta charset="UTF-8" />
                 <link rel="icon" href="./logo.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>About Forest Service | Shankar IAS Academy</title>
                <meta name="title" content="About Forest Service | Shankar IAS Academy" />
                <meta name="description" content="Discover the Forest Service with Shankar IAS Academy. Learn about roles, responsibilities, and career prospects. Empower your journey today!" />
                <link rel="canonical" href=" https://www.shankariasacademy.com/about-forestry/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="About Forest Service | Shankar IAS Academy" />
                <meta property="og:description" content="Discover the Forest Service with Shankar IAS Academy. Learn about roles, responsibilities, and career prospects. Empower your journey today!" />
                <meta property="og:url" content=" https://www.shankariasacademy.com/about-forestry/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>

      <Navbar title="upsc" />

      <div className="container">
        <div className="row pt-3 pt-md-4">
          <div className="col-md-6 col-12">
            <h1 className={`${styles.pagemaintitle}`}>About Forest Service</h1>
          </div>
          <div className="col-md-6 col-12 align-self-center text-md-end">
            <p className={`${styles.redunderline} mb-0`} style={{textDecoration:"underline"}}>
              <Link
                href="/about-upsc"
                className={`${styles.redunderlinealink}`}
              >
                Learn about Civil Service
              </Link>
            </p>
          </div>
        </div>
      </div>

      <div className="container pt-3 pt-md-2">
        <div className="row">
          <div className="col">
            <Image src={forest} className="img-fluid w-100" alt="Forest service exam" title="About forest service"/>
          </div>
        </div>
      </div>

      <div className="container pt-3">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3  align-items-baseline`}
            >
              <button
                id={styles.tablinks}
                className="nav-link tab1 py-2 px-0 me-4 active"
                data-bs-toggle="pill"
                data-bs-target="#centre-1"
                type="button"
                role="tab"
                aria-controls="centre-1"
                aria-selected="true"
              >
                About the Exam
              </button>
              <button
                id={styles.tablinks}
                className="nav-link tab2 py-2 px-0 me-4 "
                data-bs-toggle="pill"
                data-bs-target="#centre-2"
                type="button"
                role="tab"
                aria-controls="centre-2"
                aria-selected="false"
              >
                Exam structure
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-3"
                type="button"
                role="tab"
                aria-controls="centre-3"
                aria-selected="false"
              >
                Syllabus
              </button>
            </div>
          </div>
        </div>

        {/* View All Section */}

        <div className="tab-content">
          {/*  About The Exam Section Start */}
          <div className="tab-pane active" id="centre-1">
            <div className="container">
              <div className="row">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} mb-0`}>Overview</h2>
                  <p className={`${styles.acheiverrank} pt-md-2`}>
                    The Forest service exams are conducted by the UPSC. The
                    prestige, power, charm and responsibility that come along
                    with the top job like IFS are a definite reason for anyone
                    to choose Forest service a career option.
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-3">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} mb-0 pb-2`}>
                    Eligibility
                  </h2>
                  <p className={`${styles.aboutparagraph1} p-2`}>
                    <span className={`${styles.pointers} ${styles.dot}`}>
                      *
                    </span>
                    &nbsp; &nbsp; Must have attained the age of 21 on 1st August
                    of year of examination.
                  </p>
                  <p className={`${styles.aboutparagraph1} p-2`}>
                    <span className={`${styles.pointers} ${styles.dot}`}>
                      *
                    </span>
                    &nbsp; &nbsp; Must not have attained 32 years(35|37 years)
                    on 1st August of year of examination.
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-2">
                <div className="col px-0">
                  <p className={`${styles.aboutheading1} mb-0 pb-2`}>
                    Education
                  </p>
                  <p className={`${styles.acheiverrank}`}>
                    Bachelor’s Degree with atleast one of the subjects namely
                    Animal Husbandry and Veterinary Science, Physics, Chemistry,
                    Botany, Zoology, Geology, Mathematics and Statistics{" "}
                    <br></br>(or)<br></br>
                    Bachelor Degree in Agriculture, Forestry (or) Engineering
                    (Recognized by UGC/AICTE)
                  </p>
                  <p className={`${styles.acheiverrank}`}></p>
                </div>
              </div>
            </div>

            {/* Age Criteria Section */}

            <div className="container">
              <div className="row pt-3">
                <div className="col px-0">
                  <p className={`${styles.aboutheading1} mb-0 pb-2`}>
                    Age Criteria
                  </p>
                  <div className="row">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                      <div
                        className="p-3 h-100"
                        style={{ border: "1px solid #D9DFE6" }}
                      >
                        <p className={`${styles.aboutheading2}`}>General</p>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              Minimum Age
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>21</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              Maximum Age
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>32</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              No of attempts
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>6</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
                      <div
                        className="p-3 h-100"
                        style={{ border: "1px solid #D9DFE6" }}
                      >
                        <p className={`${styles.aboutheading2}`}>OBC</p>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              Minimum Age
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>21</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              Maximum Age
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>35</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              No of attempts
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>9</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-6 col-12 pt-md-3 pt-lg-0 mb-3">
                      <div
                        className="p-3 h-100"
                        style={{ border: "1px solid #D9DFE6" }}
                      >
                        <p className={`${styles.aboutheading2}`}>SC & ST</p>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              Minimum Age
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>21</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              Maximum Age
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>37</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <p className={`${styles.acheiverrank}`}>
                              No of attempts
                            </p>
                          </div>
                          <div className="col">
                            <p className={`${styles.aboutnumber}`}>No limits</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Exam schedule Section */}

            <div className="container">
              <div className="row pt-2 pt-md-4">
                <div className="col-lg-7 col-md-9 col-12 px-0">
                  <h2 className={`${styles.sectiontitle}`}>Exam Schedules</h2>
                  <div className="row mx-auto">
                    <div className="col ps-0">
                      <p className={`${styles.acheiverrank}`}>Notification</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        February / March
                      </p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col ps-0">
                      <p className={`${styles.acheiverrank}`}>
                        Preliminary Examination
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>May / June</p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col ps-0">
                      <p className={`${styles.acheiverrank}`}>
                        Preliminary Exam Results
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>July / August</p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col ps-0">
                      <p className={`${styles.acheiverrank}`}>
                        Mains Examinations
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        November / December
                      </p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col ps-0">
                      <p className={`${styles.acheiverrank}`}>
                        Mains Exam Results
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        January 1st Week / 2nd Week
                      </p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col ps-0">
                      <p className={`${styles.acheiverrank}`}>Interview</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        January / February
                      </p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col ps-0">
                      <p className={`${styles.acheiverrank}`}>Final Results</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        February / March
                      </p>
                    </div>
                    <hr></hr>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* About The Exam Section End */}

          <div className="tab-pane" id="centre-2">
            {/* Exam Structure start */}

            <div className="container">
              <div className="row">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} mb-0`}>Overview</h2>
                  <p className={`${styles.acheiverrank} pt-md-2`}>
                  Forest Service Examination consists of 3 stages as mentioned
                    below:
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-3">
                <ul className="mb-0" style={{ textdecoration: "none" }}>
                  <li className={`${styles.tlitem}`}>
                    <p className={`${styles.acheiverrank} mb-0`}>Stage 1</p>
                    <p className={`${styles.acheivername}`}>
                      Preliminary Exam (Objective Type)
                    </p>
                  </li>

                  <li className={`${styles.tlitem1}`}>
                    <p className={`${styles.acheiverrank} mb-0`}>Stage 2</p>
                    <p className={`${styles.acheivername}`}>
                      Mains Exam (Descriptive Type)
                    </p>
                  </li>

                  <li className={`${styles.tlitem2}`}>
                    <p className={`${styles.acheiverrank} mb-0`}>Stage 3</p>
                    <p className={`${styles.acheivername}`}>Interview (Oral)</p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="container">
              <div className="row pt-2">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} mb-0`}>
                    Preliminary Exam (Objective Type)
                  </h2>
                  <p className={`${styles.acheiverrank} pt-md-2`}>
                    The Preliminary Examination is conducted during May or June
                    every year. It consists of two papers - one is held in the
                    forenoon and the other in the afternoon of the same day and
                    both papers consist of a set of multiple choice questions.
                    The forenoon session is General Studies Paper–I where
                    questions are based on general awareness and other topics as
                    mentioned in the syllabus. In afternoon session is CSAT –
                    Paper II where questions based on Quantitative aptitude,
                    Reasoning and Verbal ability as mentioned in syllabus.
                    Candidates should note that there will be a penalty
                    (negative marking) for wrong answers.
                  </p>
                  <p className={`${styles.acheiverrank} pt-2`}>
                    Information given below are based on UPSC Civil Services
                    Examinations 2018.
                  </p>
                </div>
              </div>
            </div>

            <div className="container px-0">
              {/*  General Stidies Section  */}
              <div className="row">
                <div className="col-xl-4 col-lg-5 col-md-6 col-12 mb-3">
                  <div
                    className="p-3 h-100"
                    style={{ border: "1px solid #D9DFE6" }}
                  >
                    <p className={`${styles.aboutheading2}`}>
                      General Studies Paper–I
                    </p>

                    <div className="row">
                      <div className="col-8">
                        <p className={`${styles.acheiverrank}`}>
                          No. of Questions
                        </p>
                      </div>
                      <div className="col-4">
                        <p className={`${styles.aboutnumber}`}>100</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-8">
                        <p className={`${styles.acheiverrank}`}>Total Marks</p>
                      </div>
                      <div className="col-4">
                        <p className={`${styles.aboutnumber}`}>200</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-8">
                        <p className={`${styles.acheiverrank}`}>
                          Marks for Correct Answer
                        </p>
                      </div>
                      <div className="col-4">
                        <p className={`${styles.aboutnumber}`}>2</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-8">
                        <p className={`${styles.acheiverrank}`}>
                          Marks for Incorrect Answer
                        </p>
                      </div>
                      <div className="col-4">
                        <p className={`${styles.aboutnumber}`}>-0.66</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-5 col-md-6 col-12 mb-3">
                  <div
                    className="p-3 h-100"
                    style={{ border: "1px solid #D9DFE6" }}
                  >
                    <p className={`${styles.aboutheading2}`}>CSAT – Paper II</p>
                    <div className="row">
                      <div className="col-8">
                        <p className={`${styles.acheiverrank}`}>
                          No. of Questions
                        </p>
                      </div>
                      <div className="col-4">
                        <p className={`${styles.aboutnumber}`}>80</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-8">
                        <p className={`${styles.acheiverrank}`}>Total Marks</p>
                      </div>
                      <div className="col-4">
                        <p className={`${styles.aboutnumber}`}>200</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-8">
                        <p className={`${styles.acheiverrank}`}>
                          Marks for Correct Answer
                        </p>
                      </div>
                      <div className="col-4">
                        <p className={`${styles.aboutnumber}`}>2.5</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-8">
                        <p className={`${styles.acheiverrank}`}>
                          Marks for Incorrect Answer
                        </p>
                      </div>
                      <div className="col-4">
                        <p className={`${styles.aboutnumber}`}>-0.83</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-3">
                <div className="col px-0">
                  <p
                    className={`${styles.aboutparagraph1} p-2`}
                    id={styles.widthmax}
                  >
                    <span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; For
                    Wrong answers one - third of the marks assigned to that
                    question will be deducted as penalty.
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col px-0">
                  <p className={`${styles.aboutheading1} mb-0`}>Result</p>
                  <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Paper I marks is used for the selection of candidates
                          to the mains examination.
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Paper II marks is qualifying paper with a minimum
                          qualifying marks fixed at 33% (i.e 66 marks).
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Two set of results are published - one list is for
                          those who qualified for Civil Service Mains
                          Examinations and other list is for those who qualified
                          for Forest Service Mains Examination.
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          This is only a screening test, marks will not be added
                          in calculating final results.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-5">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} mb-0`}>
                    Forest Service Mains Examinations
                  </h2>
                  <p className={`${styles.acheiverrank} pt-md-2`}>
                    The candidates who qualify for Forest Services Mains
                    Examination have to choose two optional subjects which has
                    two papers each. In all, the aspirants are to appear in nine
                    papers, details of which are given below :
                  </p>
                </div>
              </div>
            </div>

            {/* Subject List Section */}

            <div className="container">
              <div className="row  pt-3">
                <div className="col-lg-7 col-md-9 col-12 px-0">
                  <div className="row mx-auto">
                    <div className="col">
                      <p className={`${styles.aboutheading2}`}>Subjects</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.aboutheading2}`}>Papers</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.aboutheading2}`}>Marks</p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        General English
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>Paper-I</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>300</p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        General Knowledge
                        <span className={`${styles.star}`}>*</span>
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>Paper-II</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>300</p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        Optional Subject - 1
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>Paper-I</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>200</p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        Optional Subject - 1
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>Paper-II</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>200</p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        Optional Subject - 2
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>Paper- I</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>200</p>
                    </div>
                    <hr></hr>
                  </div>

                  <div className="row mx-auto">
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>
                        Optional Subject - 2
                      </p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>Paper-II</p>
                    </div>
                    <div className="col">
                      <p className={`${styles.acheiverrank}`}>200</p>
                    </div>
                    <hr></hr>
                  </div>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-2">
                <div className="col px-0">
                  <p
                    className={`${styles.aboutparagraph1} p-2`}
                    id={styles.widthmax}
                  >
                    <span className={`${styles.dot}`}>*</span>&nbsp; &nbsp;
                    Answer scripts of only those candidates who have obtained
                    the minimum marks as decided by the Commission for Paper II
                    (General Knowledge) will be evaluated.
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-2 pt-md-3">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} mb-0`}>Interview</h2>
                  <p className={`${styles.acheiverrank} pt-2`}>
                    Interview for Personality test will be conducted in Delhi
                    for candidates who clear the Mains examination. (Maximum
                    mark : 275)
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-2 pt-md-3">
                <div className="col px-0">
                  <h2 className={`${styles.sectiontitle} mb-0`}>Final Results</h2>
                  <p className={`${styles.acheiverrank} pt-2`}>
                    Final Result of both Civil Services and Forest Service exam
                    will be based on Mains examination and Interview marks.
                  </p>
                </div>
              </div>
            </div>

            {/*  Exam structure end */}
          </div>

          <div className="tab-pane" id="centre-3">
            {/* syllabus start */}

            <div className="container">
              <div className="row">
                <div className="col px-0">
                  <p className={`${styles.acheiverrank} pt-md-2`}>
                    The standard of papers in General English and General
                    Knowledge will be such as may be expected of a Science or
                    Engineering graduate of an Indian University. The scope of
                    the syllabus for optional subject papers for the examination
                    is broadly of the honours degree level i.e. A level higher
                    than the bachelors degree and lower than the masters degree.
                    In the case of engineering subjects, the level corresponds
                    to the bachelors degree. There will be no practical
                    examination in any of the subjects.
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col px-0 pt-md-2">
                  <p className={`${styles.sectionsubtitle} mb-1`}>
                    Paper I - General English
                  </p>
                  <p className={`${styles.acheiverrank} mb-0`}>
                    Candidates will be required to write an essay in English.
                    Other questions will be designed to test their understanding
                    of English and workmanlike use of words.
                  </p>
                  <p className={`${styles.acheiverrank}`}>
                    Passages will usually be set for summary or precise.
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col px-0 pt-md-2">
                  <p className={`${styles.sectionsubtitle} mb-1`}>
                    Paper II - General Knowledge
                  </p>
                  <p className={`${styles.acheiverrank} mb-0`}>
                    General Knowledge including knowledge of current events and
                    of such matters of everyday observation and experience in
                    their scientific aspects as may be expected of an educated
                    person who has not made a special study of any scientific
                    subject. The paper will also include questions on Indian
                    Polity including the political system and the Constitution
                    of India, History of India and Geography of nature which the
                    candidate should be able to answer without special study.
                  </p>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-3">
                <div className="col px-0">
                  <p className={`${styles.sectionsubtitle} mb-1`}>
                    Paper III to VI - Optional Subjects
                  </p>
                  <p className={`${styles.acheiverrank} mb-3`}>
                    List of optional subjects
                  </p>
                  <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Agriculture
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Agricultural Engineering
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Animal Husbandry & Veterinary Science
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>Botany</p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Chemistry
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Chemical Engineering
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Civil Engineering
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Forestry
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>Geology</p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Mathematics
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Mechanical Engineering
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>Physics</p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Statistics
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>Zoology</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row pt-3">
                <div className="col px-0">
                  <p className={`${styles.acheiverrank} mb-3`}>
                    Provided that the candidates will not be allowed to offer
                    the following combination of subjects :
                  </p>
                  <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Agriculture and Agricultural Engg.
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Agriculture and Animal Husbandry & Veterinary Science.
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Agriculture and Forestry.
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Chemistry and Chemical Engg.
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Mathematics and Statistics.
                        </p>
                      </div>
                    </li>

                    <li
                      className={`${styles.ulliclass} ${styles.acheiverrank}`}
                      id={styles.acheiverrankspecial}
                    >
                      <div className="d-inline">
                        <p className={`${styles.ullispan} d-inline`}>
                          Of the Engineering subjects viz. Agricultural
                          Engineering, Chemical Engineering, Civil Engineering
                          and Mechanical Engineering—not more than one subject;
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Syllabus end  */}
          </div>
        </div>
      </div>

      <Interest />

      <Footer />
    </>
  );
};
export default About_Forest_Service;
